import { render } from "./LegendaTipoDocumentoDeclaracao.vue?vue&type=template&id=4156ad9c"
const script = {}

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__